import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {CultureModel} from '../../../models/localization-and-pricing/culture.model';
import {StringExtensionModel} from '../../../models/extensions/string-extension.model';
import {NavigationModel} from '../../../models/localization-and-pricing/navigation.model';

@Component({
  selector: 'app-tc',
  templateUrl: './tc.component.html',
  styleUrls: ['./tc.component.css']
})
export class TcComponent implements OnInit {

  hidden: boolean;

  constructor(private router: Router) {
  }

  ngOnInit() {
    this.hidden = true;
  }

  onPrivacyClicked() {
    this.router.navigate(NavigationModel.getHomeURLPaths(['privacy']));
  }

  onHomePageClicked() {
    this.router.navigate(NavigationModel.getHomeURLPaths(['landing']));
  }

  setHidden() {
    this.hidden = !this.hidden;
  }

}
